var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWeight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #7ec9da;\n      }\n\n      .cls-2 {\n        fill: #1d2140;\n      }\n\n      .cls-3 {\n        fill: #48bcd2;\n      }\n\n      .cls-4 {\n        fill: #273b7a;\n      }\n\n      .cls-5 {\n        fill: #396895;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M54.22,218.69H201.78c9.51,0,17.22-7.71,17.22-17.22V54.52c0-9.51-7.71-17.22-17.22-17.22H54.22c-9.51,0-17.22,7.71-17.22,17.22V201.48c0,9.51,7.71,17.22,17.22,17.22Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M201.78,37.31H127.59V218.69h74.19c9.51,0,17.22-7.71,17.22-17.22V54.52c0-9.51-7.71-17.22-17.22-17.22Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M162.1,95.72c-22.25-6.65-45.96-6.65-68.21,0-3.52,1.05-7.25-.86-8.5-4.32-2.98-8.29-5.97-16.57-8.95-24.86-1.35-3.76,.74-7.85,4.55-9.03,30.62-9.45,63.38-9.45,94,0,3.82,1.18,5.9,5.27,4.55,9.03-2.98,8.29-5.97,16.57-8.95,24.86-1.25,3.46-4.97,5.37-8.5,4.32Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M175,57.51c-15.44-4.77-31.42-7.12-47.4-7.08v40.31c11.63-.04,23.26,1.62,34.51,4.98,3.52,1.05,7.25-.86,8.5-4.32,2.98-8.29,5.97-16.57,8.95-24.86,1.35-3.76-.73-7.85-4.55-9.03Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M111.1,198.54h-46.82c-3.77,0-6.82-3.05-6.82-6.82V124.74c0-3.77,3.05-6.82,6.82-6.82h46.82c3.77,0,6.82,3.05,6.82,6.82v66.98c0,3.77-3.05,6.82-6.82,6.82Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M191.72,198.54h-46.82c-3.77,0-6.82-3.05-6.82-6.82V124.74c0-3.77,3.05-6.82,6.82-6.82h46.82c3.77,0,6.82,3.05,6.82,6.82v66.98c0,3.77-3.05,6.82-6.82,6.82Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M109.27,92.24l-14.13-28.27c-.45-.9-1.55-1.27-2.46-.82-.9,.45-1.27,1.55-.82,2.46l13.64,27.29c1.25-.24,2.51-.46,3.77-.66Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeight);
export default __webpack_public_path__ + "static/media/weight.03f7f57acc0ac9b31a60ab27be3afbe6.svg";
export { ForwardRef as ReactComponent };